export default __webpack_public_path__ + "static/media/youtube-icon.8154a56b.svg";